// extracted by mini-css-extract-plugin
export default {"button":"VariantButton_button__DdcjT","active":"VariantButton_active__xHXiX"};